import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';
import { FROM_TEXT } from '../../constants';

interface MinPriceDisplayProps {
    price: string;
    containerClassName?: string;
    fromTextClassName?: string;
    priceClassName?: string;
    size?: 'body-md' | 'body-sm' | 'body-lg';
    isDisabled?: boolean;
    disabledClassName?: string;
}

export const MinPriceDisplay: React.FC<MinPriceDisplayProps> = ({
    price,
    containerClassName,
    fromTextClassName,
    priceClassName,
    size: variant = 'body-md',
    isDisabled = false,
    disabledClassName,
}) => {
    return (
        <p
            className={classNames(containerClassName, {
                [disabledClassName || '']: isDisabled && disabledClassName,
            })}
        >
            <Typography
                variant={variant}
                className={fromTextClassName}
                as="span"
            >
                {FROM_TEXT}
            </Typography>
            <Typography
                variant={variant}
                className={classNames(priceClassName, {
                    [disabledClassName || '']: isDisabled && disabledClassName,
                })}
                as="span"
            >
                {price}
            </Typography>
        </p>
    );
};
